module.exports = __webpack_public_path__ + "static/media/due-port10.ed64d56a.jpg";